import styled from "@emotion/styled";
import IconError from "./icons/error.svg";

interface FieldErrorProps {
  block?: boolean;
}

const FieldError = styled.p<FieldErrorProps>(({ theme, block = false }) => ({
  ...theme.fonts.body,
  alignItems: "center",
  backgroundColor: theme.colors.red,
  borderRadius: theme.borderRadius.round,
  color: "black",
  fontSize: theme.fontSizes.xxs,
  marginBottom: 0,
  padding: ".4em 1em .5em",
  position: "relative",
  zIndex: 2,
  "&::before": {
    backgroundImage: `url("${IconError}")`,
    content: "''",
    display: "inline-block",
    height: "14px",
    marginRight: ".3em",
    width: "14px",
  },
  ...(block
    ? {
        display: "flex",
        width: "max-content",
      }
    : {
        display: "inline-flex",
      }),
}));

FieldError.defaultProps = {
  role: "alert",
};

export { FieldError };
